import { render, staticRenderFns } from "./Index64.vue?vue&type=template&id=a937658a&scoped=true&"
import script from "./Index64.vue?vue&type=script&lang=js&"
export * from "./Index64.vue?vue&type=script&lang=js&"
import style0 from "./Index64.vue?vue&type=style&index=0&id=a937658a&lang=less&scoped=true&"
import style1 from "./Index64.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a937658a",
  null
  
)

export default component.exports